import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propFunc } from '../../../../../../helpers/custom-prop-types';
const CheckedStep = ({ changeStep }) => (_jsx("div", Object.assign({ className: 'step-menu-circle' }, { children: _jsx("button", Object.assign({ onClick: changeStep, style: { cursor: 'pointer' }, type: 'button' }, { children: _jsx("span", { children: _jsx("i", Object.assign({ className: 'material-icons md-18' }, { children: "check" })) }) })) })));
CheckedStep.propTypes = {
    changeStep: propFunc().isRequired,
};
export default CheckedStep;
